'use client';

import confetti from 'canvas-confetti';
import { useEffect } from 'react';

export const Confetti = () => {
  const defaultConfig = {
    particleCount: 200,
    spread: 1000,
    origin: { y: 0.5 },
    colors: ['#00E73E', '#4285F4', '#EA4335', '#FBBC05'],
  };

  useEffect(() => {
    confetti({ ...defaultConfig });
  }, []);
  return <div></div>;
};
